import React from 'react';
import styled, {css} from 'styled-components'
import styles from './ServerEntry.module.css';

const ServerEntryDiv = styled.div`
  width: 400px;
  color: white;
  background-color: #222;
  font-size: 1.5em;
  font-weight: 400;
  padding: 5px 0px;
  margin: 10px;
  vertical-align: center;
`;

class ServerEntry extends React.Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return <ServerEntryDiv>
      <div class={styles.divLeft}>
        <img src={this.props.avatar} class={styles.avatar} alt="avatar"></img>
      </div>
      <div class={styles.divRight}>
        <span>{this.props.name}</span>
      </div>
    </ServerEntryDiv>
  }
}

export default ServerEntry;
